import React, {Component} from 'react';
import { VStack } from '~/native-ui/native-base';

export class VFlexPropagate extends Component {
    render() {
        const { className, ...props } = this.props;
        const stackProps = {
            ...props,
            flexGrow: props.flexGrow ?? 1,
            flexShrink: props.flexShrink ?? 0,
            flexBasis: props.flexBasis ?? props.flexGrow === 0 ? undefined : "0%",
        };

        return (
            <VStack { ...stackProps }  />
        );
    }
}